import { parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

export default function toUTC(date) {
    // Match the DateTime::ATOM format used in PHP (2022-07-06T00:00:00+00:00).
    return formatInTimeZone(parseISO(date), "GMT", "yyyy-MM-dd'T'HH:mm:ssxxx");
}
